import PropTypes from 'prop-types';

import { resolveScopedStyles } from 'core/utils/styled-jsx';

import Clock from 'core/components/Icon/Clock';

import { timeDurationInSeconds } from 'core/utils/dates';

export default function ReadDuration({ readDuration, className }) {
  const duration = timeDurationInSeconds(readDuration);
  const time = Math.ceil(duration / 60);

  if (!time || time <= 0) return null;

  const scoped = resolveScopedStyles(
    <scope>
      <style jsx>{`
        .readDuration
          white-space nowrap
        .duration
          padding-left 5px
      `}
      </style>
    </scope>
  );

  return (
    <span className={scoped.wrapClassNames('readDuration', className)}>
      <Clock />
      <span className={scoped.wrapClassNames('duration')}>
        {time}&nbsp;мин.
      </span>
      <scoped.styles />
    </span>
  );
}

ReadDuration.propTypes = {
  readDuration: PropTypes.string,
  className: PropTypes.string,
};
